module.exports = __webpack_public_path__ + "static/img/1-1Z5231I63Q22.99e260d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z5231I63Q22.jpg
// module id = UCc9
// module chunks = 0